<!-- Privacy Component -->

<template>
  <div class="terms-page">
    <section>
      <div class="container text-center">
        <h1 class="text-white banner-title">Our Privacy Notice</h1>
        <p class="banner-sub">
          Here you’ll find everything you need to know about our Terms of
          Service and Policies.
        </p>
      </div>
    </section>
    <div class="container">
      <el-row>
        <el-col :md="24" :lg="6" :xl="6">
          <div class="terms-policies">
            <terms-policies></terms-policies>
          </div>
        </el-col>
        <el-col :md="24" :lg="18" :xl="18">
          <div class="privacy-policy">
            <h3 id="main-content" class="sub-title">
              {{ privacyNotice.title }}
            </h3>
            <p>{{ privacyNotice.sub }}</p>
            <p>{{ privacyNotice.sub_1 }}</p>
          </div>
          <div class="privacy-policy">
            <h3 class="sub-title">
              {{ whatYoullFind.title }}
            </h3>
            <p>{{ whatYoullFind.firstSub }}</p>
            <p>
              By <b>‘personal information’</b> or <b>‘personal data’</b>, we
              mean any information about you that could be used to identify you.
              Anything we do with your personal information is called
              <b>processing</b>, and it applies from the moment we collect your
              data to the moment we delete it from our systems. We’ll use your
              personal information differently depending on if you register as a
              GlobalScot or a business member.
            </p>
            <ul>
              <li
                v-for="(point, index) in whatYoullFind.bulletPoints"
                :key="index"
              >
                <p class="py-1 my-0">
                  {{ point.text }}
                </p>
              </li>
            </ul>
          </div>
          <div class="privacy-policy">
            <h3 class="sub-title">
              {{ whoWeAre.title }}
            </h3>
            <p>{{ whoWeAre.firstSub }}</p>
          </div>

          <div class="privacy-policy">
            <h3 class="sub-title">
              {{ informationBeUsed.title }}
            </h3>
            <p>{{ informationBeUsed.firstSub }}</p>

            <ul>
              <li
                v-for="(point, index) in informationBeUsed.bulletPoints"
                :key="index"
              >
                <p class="py-1 my-0">
                  {{ point.text }}
                </p>
              </li>
            </ul>
          </div>

          <div class="privacy-policy">
            <h3 class="sub-title">
              The Legal Basis for using your information
            </h3>
            <p>
              The legal basis which we rely on to process your information is:
            </p>

            <table>
              <thead>
                <tr>
                  <th class="w-25">Personal Data Activity</th>
                  <th class="w-25">Legal basis - GDPR Article 6</th>
                  <th class="w-25">S8 DPA (delete as appropriate)</th>
                  <th class="w-25">UK Legislation</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="vertical-align-top">
                    <p class="py-1 my-0">Email address</p>
                    <p class="py-1 my-0">Postcode</p>
                    <p class="py-1 my-0">Date of Birth</p>
                    <p class="py-1 my-0">Living status</p>
                    <p class="py-1 my-0">Employment status</p>
                  </td>
                  <td class="vertical-align-top">
                    <p>
                      (1)(e) to do so is necessary for the performance of a task
                      carried out in the public interest, or in the exercise of
                      official authority
                    </p>
                  </td>
                  <td class="vertical-align-top">
                    <p>
                      (c) the exercise of a function conferred on a person by an
                      enactment or rule of law,
                    </p>
                    <p>
                      (e) an activity that supports or promotes democratic
                      engagement.
                    </p>
                  </td>
                  <td class="vertical-align-top">
                    <p>Health and Social Care Act 2012</p>
                  </td>
                </tr>
              </tbody>
            </table>

            <table>
              <thead>
                <tr>
                  <th class="w-25">Special Category Data Activity</th>
                  <th class="w-25">Legal basis - GDPR Article 9</th>
                  <th class="w-25">DPA 2018 condition</th>
                  <th class="w-25">Other considerations</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="vertical-align-top">
                    <p class="py-1 my-0">Gender Ethnicity</p>
                    <p class="py-1 my-0">To provide tailored support</p>
                  </td>
                  <td class="vertical-align-top">
                    <p>
                      (2)(i) processing is necessary for reasons of public
                      interest in the area of public health, such as protecting
                      against serious cross-border threats to health or ensuring
                      high standards of quality and safety of health care and of
                      medicinal products or medical devices.
                    </p>
                  </td>
                  <td class="vertical-align-top">
                    <p>Part 1 of schedule 1</p>
                  </td>
                  <td class="vertical-align-top">
                    <p>Health and Social Care Act 2012</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="privacy-policy">
            <h3 class="sub-title">
              {{ sharedWith.title }}
            </h3>
            <p>{{ sharedWith.firstSub }}</p>

            <ul>
              <li
                v-for="(point, index) in sharedWith.bulletPoints"
                :key="index"
              >
                <p class="py-1 my-0">
                  {{ point.text }}
                </p>
              </li>
            </ul>
            <p>{{ sharedWith.secondSub }}</p>
            <p>{{ sharedWith.thirdSub }}</p>
            <p>{{ sharedWith.fourthSub }}</p>
          </div>
          <div class="privacy-policy">
            <h3 class="sub-title">
              {{ keepInformation.title }}
            </h3>
            <p>{{ keepInformation.firstSub }}</p>
            <p>{{ keepInformation.secondSub }}</p>

            <table>
              <thead>
                <tr>
                  <th>Activity</th>
                  <th>Time information kept for</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <p class="py-1 my-0">Coaches case files</p>
                  </td>
                  <td>
                    <p class="py-1 my-0">
                      8-years --]from the end of the project in 2025
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="py-1 my-0">Website self referral form</p>
                  </td>
                  <td>
                    <p class="py-1 my-0">5 years from end the project 2025</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="privacy-policy">
            <h3 class="sub-title">
              {{ yourRights.title }}
            </h3>
            <p>{{ yourRights.firstSub }}</p>

            <ul>
              <li
                v-for="(point, index) in yourRights.bulletPoints"
                :key="index"
              >
                <p class="py-1 my-0">
                  {{ point.text }}
                </p>
              </li>
            </ul>
            <p v-html="yourRights.secondSub"></p>
            <p v-html="yourRights.thirdSub"></p>
          </div>
          <div class="privacy-policy">
            <h3 class="sub-title">Changes to this privacy notice</h3>
            <p>
              This notice is kept under regular review to make sure it is up to
              date and accurate.
            </p>
          </div>
          <div class="privacy-policy">
            <h3 class="sub-title">
              {{ dataProtection.title }}
            </h3>
            <p>{{ dataProtection.firstSub }}</p>

            <ul>
              <li
                v-for="(point, index) in dataProtection.bulletPoints"
                :key="index"
              >
                <p class="py-1 my-0">
                  {{ point.text }}
                </p>
              </li>
            </ul>
            <p v-html="dataProtection.secondSub"></p>
          </div>
          <div class="privacy-policy mb-5">
            <h3 class="sub-title">
              {{ contact.title }}
            </h3>
            <p>{{ contact.firstSub }}</p>
            <p>{{ contact.secondSub }}</p>
            <el-row class="pt-1">
              <el-col :sm="6">{{ contact.phone }}</el-col>
              <el-col :sm="18">{{ contact.number }}</el-col>
            </el-row>
            <el-row class="pt-1">
              <el-col :sm="6">{{ contact.website.title }}</el-col>
              <el-col :sm="18">
                <a :href="contact.website.url" target="_blank">{{
                  contact.website.url
                }}</a>
              </el-col>
            </el-row>
            <el-row class="pt-1">
              <el-col :sm="6">{{ contact.post.title }}</el-col>
              <el-col :sm="18">
                <div v-html="contact.post.address"></div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import TermsPolicies from "../../components/partials/terms-policies";
export default {
  name: "PrivacyPolicy",
  metaInfo: {
    title: "Privacy policy",
    meta: [
      {
        name: "description",
        content: "Read the privacy policy for the GlobalScot website.",
      },
    ],
  },
  components: {
    TermsPolicies,
  },
  data() {
    return {
      privacyNotice: {
        title: "Our Privacy Notice",
        sub: "This Privacy Notice sets out what you need to know about how the City of Doncaster Council will use your information for the  Well Doncaster Programme including Be Well and Community Wealth Builder ",
        sub_1:
          "The Council is committed to meeting its data protection obligations and handling your information securely.  You should make sure you read and understand this notice before submitting your information to us.",
      },
      whatYoullFind: {
        title: "What information about you do we collect?",
        firstSub:
          "For the processing to which this notice relates to be carried out we use the following information:",
        bulletPoints: [
          {
            text: "personal information – such as: your name, telephone number, age, postcode, email address, NHS number, any information you provide about yourself during coaching sessions, and details about the reason for your referral",
          },
          {
            text: "special category personal information – such as: your ethnicity, information about your physical and mental health",
          },
        ],
      },
      whoWeAre: {
        title: "How do we collect information about you?",
        firstSub:
          "We collect your information from you directly during Community conversations, via the website, coaching sessions and from health and community professionals both during the referral process and potentially throughout the time you are involved with the programme.",
      },
      informationBeUsed: {
        title: "How will your information be used",
        firstSub: "Your information might be used to:",
        bulletPoints: [
          {
            text: "contact you about services/coaching sessions available to you",
          },
          { text: "facilitate the running of coaching sessions" },
          {
            text: "maintain a record of discussions and your involvement in the sessions",
          },
          { text: "document your journey using the services offered to you" },
          { text: "feed back to health colleagues" },
          { text: "refer you to other services if required" },
          {
            text: "convert to anonymised statistics for the purposes of performance monitoring of the service.",
          },
        ],
      },
      sharedWith: {
        title: "Who will your information be shared with?",
        firstSub:
          "We sometimes need to share your information within the Council or with other organisations. We will only share your information when necessary and when the law allows us to, and we will only share the minimum information we need to. For Be Well matters we may need to share your information with:",
        bulletPoints: [
          {
            text: "Primary Care Doncaster",
          },
          {
            text: "Health and social care professionals involved with your care",
          },
          {
            text: "Sheffield Hallam University – anonymised statistics for the purposes of performance monitoring of the service",
          },
          {
            text: "When you use the website self-referral form, Ember Technology Ltd is working as a processor on behalf of City of Doncaster Council",
          },
        ],
        secondSub:
          "Information on how this will be processed by these organisations can be found in their Privacy Notices.",
        thirdSub:
          "In certain cases we may also share your information with other individuals and organisations. For example, if the sharing would help with a safeguarding issue, or help prevent a crime. Sometimes, we might share your information without your knowledge",
        fourthSub:
          "The Council will never sell your information to anyone else. ",
      },
      keepInformation: {
        title: "How long will we keep your information?",
        firstSub:
          "We will keep your information for different periods of time, depending on what we are using it for. We only keep your information for as long as we need to, after which we will securely delete the information ",
        secondSub:
          "We will keep your information for only so long as is necessary – the table below sets out typical timescales for each activity:",
      },
      yourRights: {
        title: "Your rights",
        firstSub:
          "The law gives you specific rights over your information.  These rights are:",
        bulletPoints: [
          {
            text: "to be informed of our use of information about you;",
          },
          {
            text: "of access to information about you;",
          },
          {
            text: "rectify information about you that is inaccurate;",
          },
          {
            text: "to have your information erased (the ‘right to be forgotten’);",
          },
          {
            text: "to restrict how we use information about you;",
          },
          {
            text: "to move your information to a new service provider;",
          },
          {
            text: "to object to how we use information about you; ",
          },
          {
            text: "not to have decisions made about you on the basis of automated decision making;",
          },
          {
            text: "to object to direct marketing; and,",
          },
          {
            text: "to complain about anything the Council does with your information (please see the ‘Complaints’ section below).",
          },
        ],
        secondSub:
          "Some of the rights listed above apply only in certain situations, and some have a limited effect.  Your rights are explained further in the <a href='https://www.doncaster.gov.uk/services/the-council-democracy/data-protection-policy' target='_blank' >Individuals’ Rights Procedure</a> on our website, as is how to make a request under one or more of them.",
        thirdSub:
          "You can request information about yourself by making a right of access request on <a href='https://www.doncaster.gov.uk/services/the-council-democracy/data-protection-policy' target='_blank'>this</a> page of the Council’s website.",
      },
      dataProtection: {
        title: "Data Protection Officer (DPO)",
        firstSub:
          "The Council is required by law to have a DPO.  The DPO has a number of duties, including:",
        bulletPoints: [
          {
            text: "monitoring the Council’s compliance with data protection law;",
          },
          {
            text: "providing expert advice and guidance on data protection; ",
          },
          {
            text: "acting as the point of contact for data subjects; and,",
          },
          {
            text: "co-operating and consulting with the Information Commissioner’s Office (see ‘Complaints’ below).",
          },
        ],
        secondSub:
          "The Council’s Data Protection Officer can be contacted by email at <a href='mailto:information.governance@doncaster.gov.uk'>information.governance@doncaster.gov.uk</a>",
      },
      contact: {
        title: "Complaints",
        firstSub:
          "If you are unhappy with the way in which your information has been handled you should contact the Council’s Data Protection Officer so that we can try and put things right.",
        secondSub:
          "Alternatively, and if we have been unable to resolve your complaint, you can also refer the matter to the Information Commissioner’s Office (ICO).  The ICO is the UK's independent body set up to uphold information rights, and they can investigate and adjudicate on any data protection related concerns you raise with them.  They can be contacted via the methods below:",
        phone: "Telephone:",
        number: "0303 123 1113",
        website: {
          title: "Website:",
          url: "www.ico.org.uk",
        },
        post: {
          title: "Post:",
          address:
            "<p class='my-1 py-0'>Information Commissioner’s Office</p><p class='my-1 py-0'>Wycliffe House</p><p class='my-1 py-0'>Water Lane</p><p class='my-1 py-0'>Wilmslow</p><p class='my-1 py-0'>Cheshire</p><p class='my-1 py-0'>SK9 5AF</p>",
        },
      },
    };
  },
};
</script>
